import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from './base-service.service';
import { ReservationModel } from '../models/reservation.model';
import { ReservationStatusEnum } from '../shared/enumerators/reservation-status.enum';

@Injectable({
  providedIn: 'root'
})
export class ReservationService extends BaseService<ReservationModel> {
  constructor(http: HttpClient) {
    super(http, `${environment.apiUrl}api/reservation`);
  }

  updateStatus(id: number, status: ReservationStatusEnum): Observable<any> {
    return this.http.patch(`${this.backUrl}/updateStatus/${id}`, status);
  }
}
